import { render, staticRenderFns } from "./olympus1000.vue?vue&type=template&id=2769377e&scoped=true"
import script from "./olympus1000.vue?vue&type=script&lang=js"
export * from "./olympus1000.vue?vue&type=script&lang=js"
import style0 from "./olympus1000.vue?vue&type=style&index=0&id=2769377e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2769377e",
  null
  
)

export default component.exports